<template>
  <v-dialog v-model="showDialog" persistent max-width="1300px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
      </v-card-title>-->
      <v-toolbar color="primary darken-4" dark>
        <img :src="$store.state.iconoForm" height="42" />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="formRenta" :v-model="true" lazy-validation>
            <v-tabs color="blue-grey darken-4" dark slider-color="red">
              <v-tab :href="'#tab-generales'">Generales</v-tab>
              <v-tab :href="'#tab-pagos'" v-if="renta.rentaId !== 0"
                >Pagos</v-tab
              >
              <v-tab :href="'#tab-bitacora'" v-if="renta.rentaId !== 0"
                >Bitácora</v-tab
              >
              <v-tab :href="'#tab-inventario'" v-if="renta.rentaId !== 0"
                >Inventario</v-tab
              >
              <v-tab-item :value="'tab-generales'">
                <v-layout wrap class="container">
                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      label="Folio de la renta"
                      v-model="renta.folioRenta"
                      placeholder="Folio de la renta"
                      :rules="[
                        () => !!renta.folioRenta || 'El campo es requerido',
                      ]"
                      required
                      :readonly="true"
                      color="red"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      label="Fecha renta"
                      v-model="fechaRenta"
                      placeholder="Fecha renta"
                      :readonly="true"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs6>
                    <v-text-field
                      label="Cliente"
                      v-model="renta.cliente.nombreCompletoCliente"
                      placeholder="Cliente"
                      :readonly="true"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      label="Fecha de recolección"
                      v-model="fechaRecoleccion"
                      placeholder="Fecha de recolección"
                      :readonly="true"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <div>
                      <v-icon>phone</v-icon>
                      Celular: {{ renta.cliente.telefonoCelular }}
                    </div>
                    <div>
                      <v-icon>email</v-icon>
                      Correo: {{ renta.cliente.correoContacto }}
                    </div>
                    <div>
                      <v-icon>location_on</v-icon>
                      Domicilio: {{ renta.cliente.domicilioCompleto }}
                    </div>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      label="Fecha del evento / uso"
                      v-model="fechaEvento"
                      placeholder="Fecha del evento / uso"
                      :readonly="true"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs6>
                    <v-text-field
                      label="Etapa renta"
                      v-model="renta.eventoRenta.descripcion"
                      placeholder="Etapa renta"
                      :readonly="true"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      label="Fecha comprmiso entrega del cliente"
                      v-model="fechaEntrega"
                      placeholder="Fecha comprmiso entrega del cliente"
                      :readonly="true"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <h5>CONJUNTOS</h5>
                  </v-flex>

                  <v-flex xs12>
                    <v-data-table
                      :headers="headerConjuntos"
                      :items="conjuntos"
                      hide-actions
                      class="elevation-1"
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.nombreConjunto }}</td>
                        <td>$ {{ formatMoney(props.item.precioUnitario) }}</td>
                        <td>{{ props.item.cantidad }}</td>
                        <td>
                          <b>$ {{ formatMoney(props.item.subtotal) }}</b>
                        </td>
                      </template>
                    </v-data-table>
                  </v-flex>

                  <v-flex xs12>
                    <v-data-table
                      :headers="headerProductos"
                      :items="productosConjunto"
                      hide-actions
                      class="elevation-1"
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.sku }}</td>
                        <td>{{ props.item.descripcionProducto }}</td>
                        <td>{{ props.item.descripcionTalla }}</td>
                        <td>
                          <v-icon :color="props.item.codigoHtml"
                            >widgets</v-icon
                          >
                          <span class="cb-item">{{
                            props.item.nombreColor
                          }}</span>
                        </td>
                        <td>$ {{ formatMoney(props.item.precioUnitario) }}</td>
                        <td>{{ props.item.cantidad }}</td>
                        <td>$ {{ formatMoney(props.item.subtotal) }}</td>
                      </template>
                    </v-data-table>
                  </v-flex>

                  <v-flex xs12 class="pt-4">
                    <h5>PRODUCTOS ADICIONALES</h5>
                  </v-flex>

                  <v-flex xs12>
                    <v-data-table
                      :headers="headerProductos"
                      :items="productosAdicionales"
                      hide-actions
                      class="elevation-1"
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.sku }}</td>
                        <td>{{ props.item.descripcionProducto }}</td>
                        <td>{{ props.item.descripcionTalla }}</td>
                        <td>
                          <v-icon :color="props.item.codigoHtml"
                            >widgets</v-icon
                          >
                          <span class="cb-item">{{
                            props.item.nombreColor
                          }}</span>
                        </td>
                        <td>$ {{ formatMoney(props.item.precioUnitario) }}</td>
                        <td>{{ props.item.cantidad }}</td>
                        <td>$ {{ formatMoney(props.item.subtotal) }}</td>
                      </template>
                      <template slot="footer">
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td class="text-xs-right" colspan="2">
                            <strong>SUBTOTAL PRODUCTOS</strong>
                          </td>
                          <td>
                            <b
                              >$
                              {{ formatMoney(subtotalProductosAdicionales) }}</b
                            >
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>

                  <v-flex xs12 class="pt-4">
                    <h5>TOTALES</h5>
                  </v-flex>

                  <v-flex xs12>
                    <v-data-table
                      :headers="headerTotales"
                      :items="[]"
                      hide-actions
                      no-data-text
                      no-results-text
                      class="elevation-0 table-styling table-totales"
                    >
                      <template slot="items"></template>
                      <template slot="footer">
                        <tr>
                          <td></td>
                          <td class="text-xs-right" colspan="2">
                            <strong>SUBTOTAL</strong>
                          </td>
                          <td class="text-xs-right">
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="renta.subtotal"
                                prefix="$"
                                :readonly="true"
                              ></v-text-field>
                            </v-flex>
                          </td>
                        </tr>
                        <tr v-if="renta.porcentajeDescuento != 0">
                          <td></td>
                          <td class="text-xs-right" colspan="2">
                            <strong>DESCUENTO %</strong>
                          </td>
                          <td class="text-xs-right">
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="renta.porcentajeDescuento"
                                :readonly="true"
                              ></v-text-field>
                            </v-flex>
                          </td>
                        </tr>
                        <tr v-if="renta.montoDescuento != 0">
                          <td></td>
                          <td class="text-xs-right" colspan="2">
                            <strong>MONTO DESCUENTO</strong>
                          </td>
                          <td class="text-xs-right">
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="renta.montoDescuento"
                                :readonly="true"
                              ></v-text-field>
                            </v-flex>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td class="text-xs-right" colspan="2">
                            <strong>SUBTOTAL CON DESCUENTO</strong>
                          </td>
                          <td class="text-xs-right">
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="renta.total"
                                prefix="$"
                                :readonly="true"
                              ></v-text-field>
                            </v-flex>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td class="text-xs-right" colspan="2">
                            <strong>IVA</strong>
                          </td>
                          <td class="text-xs-right">
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="renta.iva"
                                prefix="$"
                                :readonly="true"
                              ></v-text-field>
                            </v-flex>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td class="text-xs-right" colspan="2">
                            <strong>TOTAL</strong>
                          </td>
                          <td class="text-xs-right">
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="renta.totalFinal"
                                prefix="$"
                                :readonly="true"
                              ></v-text-field>
                            </v-flex>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-tab-item>
              <v-tab-item :value="'tab-pagos'">
                <renta-pagos
                  :renta="renta"
                  @onPagoAdded="onPagoAdded"
                  @onPagoUpdated="onPagoUpdated"
                  @onPagoDeleted="onPagoDeleted"
                ></renta-pagos>
              </v-tab-item>
              <v-tab-item :value="'tab-bitacora'">
                <renta-bitacora :renta="renta"></renta-bitacora>
              </v-tab-item>
              <v-tab-item :value="'tab-inventario'">
                <v-flex xs12>
                  <v-data-table
                    :headers="headerInventarios"
                    :items="renta.desgloseProductos"
                    hide-actions
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.sku }}</td>
                      <td>{{ props.item.descripcionProducto }}</td>
                      <td>{{ props.item.descripcionTalla }}</td>
                      <td>
                        <v-icon :color="props.item.codigoHtml">widgets</v-icon>
                        <span class="cb-item">{{
                          props.item.nombreColor
                        }}</span>
                      </td>
                      <td>{{ props.item.cantidad }}</td>
                      <td>
                        <v-text-field
                          label="Cantidad a tintorería"
                          v-model="props.item.cantidadTintoreria"
                          :disabled="true"
                          type="number"
                          :rules="[
                            () =>
                              props.item.cantidadTintoreria >= 0 ||
                              'No puede ser negativo!',
                            () =>
                              props.item.cantidadTintoreria <=
                                props.item.cantidad ||
                              'No puede ser mayor a la cantidad solicitada!',
                          ]"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          label="Cantidad devuelta"
                          v-model="props.item.cantidadDevuelta"
                          :disabled="
                            renta.eventoRentaId !== 8 ||
                            props.item.cantidadTintoreria === 0
                          "
                          type="number"
                          :rules="[
                            () =>
                              props.item.cantidadDevuelta >= 0 ||
                              'No puede ser negativo!',
                            () =>
                              props.item.cantidadDevuelta <=
                                props.item.cantidad ||
                              'No puede ser mayor a la cantidad solicitada!',
                          ]"
                          @change="updateInventario(props.item)"
                        ></v-text-field>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-tab-item>
            </v-tabs>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <!-- <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="saveRenta"
        >Guardar</v-btn>-->
      </v-card-actions>

      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >Renta registrada con éxito</v-alert
      >
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
    <snack-bar></snack-bar>
    <confirm ref="confirm"></confirm>
  </v-dialog>
</template>

<script>
//Global Components
import snackBar from "@/components/SnackBar";
import VWidget from "@/components/VWidget";
import moment from "moment";
import confirm from "@/components/dialogs/Confirm";

import rentaPagos from "@/views/renta-pagos/RentaPagos";
import rentaBitacora from "@/views/renta-bitacora/RentaBitacora";
import rentaService from "@/services/rentaService";

export default {
  components: {
    VWidget,
    snackBar,
    rentaPagos,
    rentaBitacora,
    confirm,
  },
  props: {
    renta: {
      type: Object,
      required: false,
    },
  },
  watch: {
    renta: function (n) {
      this.getConjuntos();
      this.getProductosConjunto();
      this.getProductosAdicionales();
    },
  },
  computed: {
    fechaRenta: function () {
      return moment(this.renta.fechaRenta).format("LL");
    },
    fechaRecoleccion: function () {
      return moment(this.renta.fechaRecoleccion).format("LL");
    },
    fechaEvento: function () {
      return moment(this.renta.fechaEvento).format("LL");
    },
    fechaEntrega: function () {
      return moment(this.renta.fechaEntrega).format("LL");
    },
  },
  data() {
    return {
      showDialog: false,
      headerConjuntos: [
        {
          text: "CONJUNTO",
          align: "left",
          sortable: true,
          width: "68%",
          value: "nombreConjunto",
        },
        {
          text: "PRECIO UNITARIO",
          align: "center",
          sortable: false,
          value: "precioUnitario",
        },
        {
          text: "CANTIDAD",
          align: "center",
          sortable: false,
          value: "cantidad",
        },
        {
          text: "SUBTOTAL",
          align: "center",
          sortable: false,
          value: "subtotal",
        },
      ],
      headerProductos: [
        { text: "SKU", align: "center", sortable: true, value: "sku" },
        {
          text: "PRODUCTO",
          align: "center",
          sortable: false,
          value: "descripcionProducto",
        },
        {
          text: "TALLA",
          align: "center",
          sortable: false,
          value: "descripcionTalla",
        },
        {
          text: "COLOR",
          align: "center",
          sortable: false,
          value: "nombreColor",
        },
        {
          text: "P / UNITARIO",
          align: "center",
          sortable: false,
          value: "precioUnitario",
        },
        {
          text: "CANTIDAD",
          align: "center",
          sortable: false,
          value: "cantidad",
        },
        {
          text: "SUBTOTAL",
          align: "center",
          sortable: false,
          value: "subtotal",
        },
      ],
      headerTotales: [
        { text: "", align: "left", width: "30%", sortable: false },
        {
          text: "",
          align: "center",
          width: "40%",
          sortable: false,
        },
        { text: "", align: "center", width: "10%", sortable: false },
        { text: "TOTALES", align: "center", width: "20%", sortable: false },
      ],
      headerInventarios: [
        { text: "SKU", align: "center", sortable: true, value: "sku" },
        {
          text: "PRODUCTO",
          align: "center",
          sortable: false,
          value: "descripcionProducto",
        },
        {
          text: "TALLA",
          align: "center",
          sortable: false,
          value: "descripcionTalla",
        },
        {
          text: "COLOR",
          align: "center",
          sortable: false,
          value: "nombreColor",
        },

        {
          text: "CANTIDAD",
          align: "center",
          sortable: false,
          value: "cantidad",
        },
        {
          text: "A TINTORERÍA",
          align: "center",
          sortable: false,
          value: "cantidadTintoreria",
        },
        {
          text: "A INVENTARIO",
          align: "center",
          sortable: false,
          value: "cantidadDevuelta",
        },
      ],
      conjuntos: [],
      productosConjunto: [],
      productosAdicionales: [],
      subtotalProductosAdicionales: 0,
    };
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    getConjuntos() {
      let self = this;
      self.conjuntos = self.renta.desgloseConjunto;
    },
    getProductosConjunto() {
      let self = this;
      self.productosConjunto = self.renta.desgloseProductos.filter(
        (p) => p.esConjunto === true
      );
    },
    getProductosAdicionales() {
      let self = this;
      self.productosAdicionales = self.renta.desgloseProductos.filter(
        (p) => p.esConjunto !== true
      );
      self.productosAdicionales.forEach((element) => {
        self.subtotalProductosAdicionales = element.subtotal;
      });
    },
    onPagoAdded(rentaPago) {
      this.resetTitles();
      this.$emit("onPagoAdded", rentaPago);
    },
    onPagoUpdated(rentaPago) {
      this.resetTitles();
      this.$emit("onPagoUpdated", rentaPago);
    },
    onPagoDeleted(rentaPago) {
      this.resetTitles();
      this.$emit("onPagoDeleted", rentaPago);
    },
    resetTitles() {
      this.$store.state.tituloForm = "VISUALIZAR RENTA";
      this.$store.state.iconoForm = "/images/general/actualizar-40.png";
    },
    updateInventario(detalleProducto) {
      let self = this;

      let cantidadDevuelta = Number(detalleProducto.cantidadDevuelta);
      detalleProducto.rentaId = self.renta.rentaId;

      if (
        cantidadDevuelta <= detalleProducto.cantidad &&
        cantidadDevuelta <= detalleProducto.cantidadTintoreria
      ) {
        this.$refs.confirm
          .open(
            "ACTUALIZAR INVENTARIO",
            "¿Estás seguro de devolver " +
              cantidadDevuelta +
              " elemento(s) al inventario?",
            { color: "red" }
          )
          .then((confirm) => {
            if (confirm) {
              detalleProducto.cantidadTintoreria =
                detalleProducto.cantidad - cantidadDevuelta;

              rentaService
                .updateDetalleRentaEntrega(detalleProducto)
                .then((result) => {
                  self.$store.state.snackbar.color = "success";
                  self.$store.state.snackbar.text =
                    "Renta actualizada... actualizando inventario";
                  self.$store.state.snackbar.visible = true;

                  rentaService
                    .devolverProducto(detalleProducto)
                    .then((result) => {
                      self.$store.state.snackbar.color = "success";
                      self.$store.state.snackbar.text =
                        "Inventario actualizado";
                      self.$store.state.snackbar.visible = true;
                    })
                    .catch((e) => {
                      self.operationFailed(e);
                      console.log(e);
                    });
                })
                .catch((e) => {
                  self.operationFailed(e);
                  console.log(e);
                });
            } else {
              self.$store.state.snackbar.color = "Cancelar";
              self.$store.state.snackbar.text = "Operación cancelada";
              self.$store.state.snackbar.visible = true;
            }
          });
      }
    },
  },
};
</script>

<style>
.v-btn-30 {
  height: 30px !important;
  width: 30px !important;
}
</style>
